import ApiServiceCustom from "../services/ApiServiceCustom";

const escolas = async () => {
  const dados = await ApiServiceCustom.get({
    defaultUrl: process.env.VUE_APP_ADMINISTRACAO_ESCOLAR_API,
    resource: "escola",
    slug: "/listagem",
  }).then(({ data }) => {
    return data.dados.map((data) => {
      return {
        value: data.id,
        label: data.nome,
      };
    });
  });
  return dados;
};

const escolasPorRedeEnsinoEMunicipio = async (rede_ensino, municipio_id) => {
  if (!rede_ensino || !municipio_id) {
    return;
  }
  const dados = await ApiServiceCustom.get({
    defaultUrl: process.env.VUE_APP_ADMINISTRACAO_ESCOLAR_API,
    resource: "escola",
    slug: `/listagem_rede_ensino_municipio/${rede_ensino}/${municipio_id}`,
  }).then(({ data }) => {
    return data.dados.map((data) => {
      return {
        value: data.id ? data.id : data.escola_id,
        label: data.nome,
      };
    });
  });
  return dados;
};

const obterEscolas = async (coordenadoria_id, defaultUrl) => {
  if (!coordenadoria_id) {
    return;
  }
  const dados = await ApiServiceCustom.get({
    defaultUrl: defaultUrl,
    resource: "escola",
    slug: `/coordenadoria/${coordenadoria_id}`,
  }).then(({ data }) => {
    return data.dados.map((data) => {
      return {
        value: data.id,
        label: data.nome,
        classificacao: data.classificacao,
      };
    });
  });
  return dados;
};

const escolasPerfilDeDados = async (coordenadoria_id) => {
  return await obterEscolas(coordenadoria_id, process.env.VUE_APP_ADMIN_API);
};

const escolasPorCoordenadoria = async (coordenadoria_id) => {
  return await obterEscolas(
    coordenadoria_id,
    process.env.VUE_APP_ADMINISTRACAO_ESCOLAR_API
  );
};

export {
  escolas,
  escolasPorRedeEnsinoEMunicipio,
  escolasPorCoordenadoria,
  escolasPerfilDeDados,
};
